module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v1/5chap1#chap1"
    }
  }, [_c('i', [_vm._v("To the Reader")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/6chap2#chap2"
    }
  }, [_c('i', [_vm._v("Yonder Peasant, Who Is He?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/8chap3#chap3"
    }
  }, [_c('i', [_vm._v("A Tin Butterfly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/10chap4#chap4"
    }
  }, [_c('i', [_vm._v("The Blackguard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/11chap5#chap5"
    }
  }, [_c('i', [_vm._v("C’est le Premier Pas Qui Coûte")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/12chap6#chap6"
    }
  }, [_c('i', [_vm._v("Names")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/14chap7#chap7"
    }
  }, [_c('i', [_vm._v("The Figures in the Clock")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/16chap8#chap8"
    }
  }, [_c('i', [_vm._v("Yellowstone Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/v1/18chap9#chap9"
    }
  }, [_c('i', [_vm._v("Ask Me No Questions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/v1/19chap10#chap10"
    }
  }, [_vm._v("Image Gallery")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb73efe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v1/4-TOC.vue
// module id = 78
// module chunks = 0